import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { GridCellParams } from 'cloud-shared-lib';

export interface CommentChangeEvent {
  uid: string;
  value: string;
}

@Component({
  template: `
    <mat-form-field class="no-label dense-input no-subscript w-full" appearance="outline">
      <input
        matInput
        [value]="params?.row?.comment || ''"
        readonly
        [matMenuTriggerFor]="noteMenu"
        [matTooltip]="params?.row?.comment || ''"
        i18n-matTooltip />
    </mat-form-field>

    <mat-menu #noteMenu="matMenu" class="custom-panel-remark-popup-full-edit-panel">
      <mat-form-field
        appearance="outline"
        (click)="$event.stopPropagation()"
        class="w-full dense-input no-subscript no-label">
        <textarea
          matInput
          [value]="params?.row?.comment || ''"
          (input)="updateComment($event)"
          cols="50"
          rows="7"
          appearance="outline"
          i18n-placeholder
          placeholder="Примечание">
        </textarea>
      </mat-form-field>
    </mat-menu>
  `,
  standalone: true,
  imports: [MatFormFieldModule, MatTooltipModule, MatInputModule, FormsModule, ReactiveFormsModule, MatMenuModule],
})
export class CadModelDetailsCellNoteComponent {
  @Input() params: GridCellParams;
  @Input() data: { saveChanges?: (event: CommentChangeEvent) => void };

  updateComment(event: Event): void {
    const value = (event.target as HTMLTextAreaElement).value;

    this.params.row[this.params.field] = value;

    this.data.saveChanges({
      uid: this.params.row.uid,
      value: value,
    });
  }
}
